function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 4H4.00004C2.53337 4 1.33337 5.2 1.33337 6.66667V25.3333C1.33337 26.8 2.53337 28 4.00004 28H28C29.4667 28 30.6667 26.8 30.6667 25.3333V6.66667C30.6667 5.2 29.4667 4 28 4ZM28 22.3333C28 23.9902 26.6569 25.3333 25 25.3333H7.00004C5.34319 25.3333 4.00004 23.9902 4.00004 22.3333V9.66666C4.00004 8.00981 5.34319 6.66667 7.00004 6.66667H25C26.6569 6.66667 28 8.00981 28 9.66667V22.3333ZM10.6667 20C10.6667 17.7867 12.4534 16 14.6667 16C15.1334 16 15.5867 16.0933 16 16.24V8H20C21.4728 8 22.6667 9.19391 22.6667 10.6667H18.6667V20.04C18.64 22.2267 16.8667 24 14.6667 24C12.4534 24 10.6667 22.2133 10.6667 20Z",
  fill: "#FBFBFB"
});

var SvgStagehallUnselected = function SvgStagehallUnselected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStagehallUnselected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stagehall-unselected.6654dad3.svg";
export { ForwardRef as ReactComponent };